import { Link } from "react-router-dom";
import { Phone, MessageCircle, MapPin, ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";
import { PHONE, PHONE_DISPLAY, WHATSAPP_MSG } from "../lib/data";

export const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="relative border-t border-white/10 bg-[#000000] pt-20 pb-10"
    >
      <div className="mx-auto max-w-[90rem] px-6 md:px-12">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <Logo className="h-11" />
            <p className="mt-6 max-w-sm text-white/75 leading-relaxed">
              A performance marketing & branding agency out of Mumbai. Five years
              turning ambitious brands into category leaders.
            </p>
            <div className="mt-6 flex items-center gap-2 text-white/75">
              <MapPin size={18} className="text-white" />
              <span>Mumbai, Maharashtra, India</span>
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-mono text-xs uppercase tracking-[0.2em] text-white/65">
              Explore
            </h4>
            <ul className="mt-5 space-y-3">
              <li>
                <Link to="/" className="text-white/70 hover:text-white transition-colors">Home</Link>
              </li>
              <li>
                <Link to="/booking" data-testid="footer-booking" className="text-white/70 hover:text-white transition-colors">Book Appointment</Link>
              </li>
              <li>
                <Link to="/privacy" data-testid="footer-privacy" className="text-white/70 hover:text-white transition-colors">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms" data-testid="footer-terms" className="text-white/70 hover:text-white transition-colors">Terms &amp; Conditions</Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-mono text-xs uppercase tracking-[0.2em] text-white/65">
              Get in touch
            </h4>
            <div className="mt-5 space-y-3">
              <a
                href={`https://wa.me/${PHONE.replace("+", "")}?text=${WHATSAPP_MSG}`}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-whatsapp"
                className="group flex items-center justify-between rounded-2xl border border-white/10 px-5 py-4 hover:border-white/60 transition-colors"
              >
                <span className="flex items-center gap-3 text-white">
                  <MessageCircle size={20} className="text-white" /> WhatsApp Us
                </span>
                <ArrowUpRight className="text-white/65 group-hover:text-white transition-colors" size={18} />
              </a>
              <a
                href={`tel:${PHONE}`}
                data-testid="footer-call"
                className="group flex items-center justify-between rounded-2xl border border-white/10 px-5 py-4 hover:border-white/60 transition-colors"
              >
                <span className="flex items-center gap-3 text-white">
                  <Phone size={20} className="text-white" /> {PHONE_DISPLAY}
                </span>
                <ArrowUpRight className="text-white/65 group-hover:text-white transition-colors" size={18} />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-4 border-t border-white/10 pt-8 md:flex-row md:items-center md:justify-between">
          <p className="text-sm text-white/65">
            © {new Date().getFullYear()} Adinvo. All rights reserved.
          </p>
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-white/70">
            Marketing · Branding · Development
          </p>
          <Link
            to="/admin/login"
            data-testid="footer-admin"
            className="font-mono text-xs uppercase tracking-[0.2em] text-white/75 hover:text-white/65 transition-colors"
          >
            Admin
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
